import request from '@/utils/request'

//查询全部带分页
export function userList(data) {
  return request({
    url: '/admin_user/v1/list',
    method: 'post',
    data
  })
}

//查询全部带分页
export function userListAll(data) {
  return request({
    url: '/admin_user/v1/listAll',
    method: 'GET',
    params: data
  })
}

//添加用户
export function userAdd(data) {
  return request({
    url: '/admin_user/v1/add',
    method: 'post',
    data
  })
}

//删除用户
export function userDelete(data) {
  return request({
    url: '/admin_user/v1/delete',
    method: 'get',
    params: data
  })
}

//编辑用户
export function userEdit(data) {
  return request({
    url: '/admin_user/v1/edit',
    method: 'post',
    data
  })
}

//根据用户主键ID取得用户详情
export function detailId(data) {
  return request({
    url: '/admin_user/v1/detail',
    method: 'get',
    params: data
  })
}

//关联的项目
export function listProject(data) {
  return request({
    url: '/admin_user/v1/listProject',
    method: 'get',
    params: data
  })
}
